// Review ekranı kayıt geri bildirimi — tek kopya kaynağı (satır içi string yazılmaz).
export const REVIEW_COPY = {
  saveFailed: "Kaydedilemedi — değişiklikleriniz editörde duruyor, tekrar Kaydet'e basın.",
  saveConflict:
    "Bölüm bu arada başka bir işlemle güncellendi — değişiklikleriniz editörde duruyor, kaydetmeden önce kontrol edin.",
  nothingToSave: "Kaydedilecek değişiklik yok",
  // Final review I2 — kirli editörde sunucu metni değişti
  serverChangedText: "Bu bölümün metni sunucuda değişti (yeniden üretim / KK).",
  serverChangedTake: "Sunucu metnini al",
  serverChangedKeep: "Benimkini koru",
  unsavedBlocksAction: "Önce kaydedin ya da değişiklikleri geri alın",
  discardLocal: "Değişiklikleri geri al",
  // Finar 14.7 (K5) — bölüm bazlı "Yeniden üret" (Aksiyonlar paneli)
  regenerate: {
    button: "Yeniden üret",
    title: "Bölüm yeniden üretilsin mi?",
    // Not: bölüm metninin sürüm tarihçesi tablosu yok — aynı sürüm ezilir; ilk üretim metni
    // "Orijinal ↔ Düzenlenmiş" görünümünde, önceki metin işlem kaydında (section.regenerate) kalır.
    body: (cost: string): string =>
      `Bu bölüm yeniden üretilecek; mevcut metin yeni sürümle değişir. İlk üretilen metin "Orijinal ↔ Düzenlenmiş" görünümünde kalır, önceki metin işlem kaydına yazılır. Tahmini maliyet ${cost}`,
    costLoading: "hesaplanıyor…",
    costUnknown: "hesaplanamadı",
    confirm: "Yeniden üret",
    disabledDirty: "Önce kaydedin ya da değişiklikleri geri alın",
    disabledApproved: "Onaylı bölüm yeniden üretilemez — önce yeniden açın",
    disabledRunning: "Bu bölümde üretim ya da KK sürüyor",
    disabledQcPending: "Önce bekleyen KK önerisine karar verin",
    started: "Yeniden üretim başladı — metin hazır olunca güncellenecek",
    failed: "Yeniden üretim başlatılamadı",
  },
  // Final review I1 — yeniden üretim sürerken onay pasif (yeni metin onaylı metni ezerdi)
  approve: {
    disabledQcPending: "Önce KK adayına karar verin",
    disabledDirty: "Önce kaydet",
    disabledGenerating: "Bölüm yeniden üretiliyor — yeni metin gelince onaylayın",
    bulkDisabledQcPending: "Önce bekleyen KK adaylarına karar verin",
    bulkDisabledGenerating: "Yeniden üretim sürüyor — bitince toplu onaylayın",
    bulkDone: (n: number): string => `${n.toString()} bölüm onaylandı`,
    bulkSkipped: (n: number): string => ` · ${n.toString()} bölüm üretim sürdüğü için atlandı`,
  },
  // Finar 14.11 (K6) — filigranlı "Taslak Word (ön izleme)": onay şartsız, nihai rapordan ayrı
  draftPreview: {
    button: "Taslak Word (ön izleme)",
    hint: "Bölümlerin şu anki metni — onaysız, her sayfada TASLAK işaretli. Nihai rapor yerine geçmez.",
    started: "Taslak hazırlandı — indirme açıldı",
    failed: "Taslak oluşturulamadı",
  },
} as const;
